import React, { FunctionComponent } from "react";
import { CopyrightBar } from "./styles";

const Footer: FunctionComponent = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <>
      <CopyrightBar>
        <p className="mb-0">Bharath Vadde Copyright © {currentYear}. All rights reserved.</p>
      </CopyrightBar>
    </>
  );
};

export default Footer;
